import {Routes} from '@angular/router';
import {FormationComponent} from './formation.component';
import {FormationDetailComponent} from './formation-detail.component';
import {FormationDeletePopupComponent} from './formation-delete-dialog.component';
import {UserRouteAccessService} from '../../shared';
import {FormationNewPopupComponent} from './formation-new-dialog.component';


export const formationRoute: Routes = [
    {
        path: 'formation',
        component: FormationComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'formation-back/:id',
        component: FormationComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'formation/:id',
        component: FormationDetailComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const formationPopupRoute: Routes = [
    {
        path: 'formation-new',
        component: FormationNewPopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'formation/:id/delete',
        component: FormationDeletePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
            pageTitle: 'cadensApp.formation.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/formation.route.ts